'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (initialState, handlers) {
  if (!initialState || !handlers) {
    throw new Error('must pass args of "initialState" and "handlers" to createReducer!');
  }

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action && action.type) {
      var type = action.type;

      if (!handlers[type]) {
        return state;
      }

      return handlers[type](state, action);
    }

    return state;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/utils/createReducer.js
// module id = 4eO1
// module chunks = 4